var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resolution"},[_c('div',{staticClass:"resolution__indicator"},[_c('BaseIndicator',{attrs:{"color":_vm.dpiIndicatorColor}})],1),_c('span',{staticClass:"resolution__text"},[_vm._v(_vm._s(_vm.dpi)+"dpi")])])
}
var staticRenderFns = []

export { render, staticRenderFns }